import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });
  
  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);
    
    {/* replace below with your own Service ID, Template ID and Public Key from your EmailJS account */ }
    
    emailjs
      .sendForm("YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", e.target, "YOUR_PUBLIC_KEY")
      .then(
        (result) => {
          console.log(result.text);
          clearState();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
          <img src="img/logo.png"></img>
           <h3>Cancellation Policy</h3>
           <p>Please understand that appointments canceled without giving enough notice (less than 24 hours), we miss the opportunity to fill in that appointment time and clients on our waiting list miss the opportunity to receive services. Since the services are reserved for you personally, a 50% cancellation fee will apply to your Credit Card. Same day cancellations, or last minute cancellations, or “no shows” will be charged 50% on your credit card from the full service price scheduled. Repeated cancellations without adequate 24 hours prior notice (more than 5 times) our Episode Salon & Spa will not be able to schedule any more appointments for you. Thank you & Appreciate for your understanding.</p>
          <h3>Service Redo</h3>
          <p>Services received cannot be refunded. If you are not satisfied with the work performed, we require that you return to our salon so that your hair can be visually inspected within 7 days. At that time, we will make every effort to correct any problems to your satisfaction by rescheduling you with the stylist who performed the initial service, at no additional charge to you. We will be happy to adjust any service 1 time within 7 days of your original service. Thank You.</p>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone / Text
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
            <h3>Business Hours</h3>
            <p>Monday Closed</p>
<p>Tuesday 10:00AM - 8:00PM</p>
<p>Wednesday 10:00AM - 8:00PM</p>
<p>Thursday 10:00AM - 8:00PM</p>
<p>Friday 10:00AM - 8:00PM</p>
<p>Saturday 9:30AM - 7:30PM</p>
<p>Sunday 9:30AM - 7:30PM</p>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.instagram : "/"}>
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.tiktok : "/"}>
                      <i className="fa">
                        <img width="25px" height="25px" src="/img/tiktok.png"></img>
                      </i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.youtube : "/"}>
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
